import { GoodOutStateTypes, GoodOutActionTypes } from "./GoodOut.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: GoodOutStateTypes = {
  fetchAll: resetApiCallState([]),
};

const GoodOutReducer = (
  state: GoodOutStateTypes = INITIAL_STATE,
  action: any
): GoodOutStateTypes => {
  switch (action.type) {
    case GoodOutActionTypes.FETCH_ALL_GOOD_OUT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodOutActionTypes.FETCH_ALL_GOOD_OUT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case GoodOutActionTypes.FETCH_ALL_GOOD_OUT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodOutActionTypes.FETCH_ALL_GOOD_OUT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default GoodOutReducer;
